import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldGroup } from '../../../libs/formLib';
import ButtonIcon from '../../common/ButtonIcon';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import { useScheduling } from '../../../hooks/useScheduling';
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  FormGroup,
  Label,
  ListGroup,
  ListGroupItem,
  Row,
  TabContent,
  TabPane
} from 'reactstrap';
import { animateScroll } from 'react-scroll';
import { sumBy } from 'lodash';

import SummaryModal from '../Vendor/Modal';
import CredsModal from '../Vendor/CredsModal';
import BZAPIService from '../../../services/BZAPIService';
import ProductPriority from '../section/ProductPriority';
import DefaultConfigTab from '../section/DefaultConfigTab';
import TabNav from '../section/TabNav';
import TabOne from '../section/TabOne';
import ExecutionStatsTab from '../section/ExecutionStatsTab';
import RiskScore from '../section/RiskScore';

// constants
import SETTINGS from '../../../constants/settings';

const ConfigFormNetApp = ({
  vendor,
  vendorLabel,
  isReadOnly,
  vendorId,
  vendorPriorityOptions,
  vendorStatusOptions,
  bugsDateBack,
  setBugsDateBack,
  snIntegrationCheck,
  services,
  vendors,
  // bugs,
  priorityStats,
  snCompanySysIdOptions,
  snCompanySysIdErrors,
  snCompanySysId,
  setSnCompanySysId,
  fields,
  handleFieldChange,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  keywords,
  setKeywords,
  searchFields,
  setSearchFields,
  setServices,
  setVendors,
  buildVendorStat,
  setPriorityStats,
  setBugs,
  isConfigured,
  syncOnly,
  setSyncOnly,
  customers,
  setCustomers,
  loading,
  vendorRiskCategoryOptions,
  vendorRiskCategories,
  setVendorRiskCategories,
  isCve,
  setIsCve,
  vendorMitigationTypes,
  setVendorMitigationTypes,
  vendorMitigationTypeOptions,
  isServiceActive,
  setIsServiceActive,
  allRequired,
  setAllRequired,
  isUpdated,
  setIsUpdated,
  bugRisk,
  setBugRisk
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);
  const [isUpdatingCreds, setIsUpdatingCreds] = useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);
  const [isForceRun, setIsForceRun] = useState(false);
  const [riskError, setRiskError] = useState('');

  // Use scheduling hook for state and save function
  const {
    timeUnit,
    setTimeUnit,
    timeValue,
    setTimeValue,
    schedulingMode,
    setSchedulingMode,
    schedules,
    setSchedules,
    nextRun,
    setNextRun,
    saveBugServiceFrequency
  } = useScheduling();

  async function setBugServiceFrequency() {
    await saveBugServiceFrequency(vendorId);
  }

  async function saveServiceAWSSecret() {
    const data = {
      secret: {
        refresh_token: fields.refreshToken
      },
      vendorId: 'netapp',
      key: 'activeiq'
    };
    // service api secret
    if (fields.refreshToken.length > 1) {
      return BZAPIService.createOrUpdateAWSSecret(data);
    } else {
      console.log('please specify a refresh token');
    }
  }
  function cancelCreds() {
    fields.refreshToken = '';
    setIsAddingCredentials(false);
    setIsAddingCredentials(false);
  }

  async function testCreds() {
    setIsTestingValidCredentials(true);
    const data = {
      serviceRefreshToken: fields.refreshToken
    };
    try {
      const result = await BZAPIService.vendorTestCreds(vendorId, data);
      setIsTestingValidCredentials(false);
      if (result && result.completed) {
        // valid creds
        console.log('result.active_iq_customers', result.active_iq_customers);
        fields.refreshToken = result.refresh_token;
        setIsValidCredentials(true);
        setCustomers([...result.active_iq_customers]);
        setIsAddingCredentials(false);
        setIsUpdatingCreds(true);
        toast.success(`Refresh token validated.`);
      }
      if (result && !result.completed) {
        toast.error(result.message);
        setIsAddingCredentials(false);
      }
    } catch (e) {
      setIsTestingValidCredentials(false);
      toast.error(`Unable to validate refresh token.`);
      console.log('error: ', e);
    }
  }

  async function saveConfig(serviceSecret) {
    // save client config
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      bugsDateBack: bugsDateBack,
      secretId: serviceSecret.Name,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      activeIqCustomers: customers,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      vendorPriorities,
      vendorMitigationTypes,
      vendorRiskCategories,
      isCve,
      type: SETTINGS.VENDOR,
      excludedKws: keywords,
      searchFields: searchFields,
      bugRiskScore: bugRisk
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data, isForceRun, isUpdatingCreds);
  }

  async function handleSave() {
    try {
      setIsSubmitted(true);
      setIsLoading(true);
      // Validate
      if (!snCompanySysId || !bugsDateBack.length) {
        console.log('failed validation');
        setValidated(false);
        setActiveTab('3');
        setIsLoading(false);
        return;
      }

      if (!priorityMaps.length || !vendorRiskCategories.length) {
        setValidated(false);
        setActiveTab('4');
        setIsLoading(false);
        return;
      }

      // Validate Secrets
      if (!fields.secretId) {
        if (!fields.refreshToken) {
          toast.error('Missing secret');
          setIsLoading(false);
          setActiveTab('2');
          setValidated(false);
          return;
        }
      }
      // Validate Risk Score
      const activeRisk = bugRisk.filter(y => {
        return y.active;
      });
      const activeSum = sumBy(activeRisk, risk => {
        return risk.value;
      });

      if (activeSum < 100 && activeSum > 1) {
        console.log('Bug risk share is less than 100');
        setValidated(false);
        setIsLoading(false);
        setActiveTab('5');
        setRiskError('Bug risk share total must be 100');
        return;
      }

      let serviceSecret;

      if (fields.refreshToken) {
        // Updated secrets
        serviceSecret = await saveServiceAWSSecret();
      } else {
        // use existing secrets
        serviceSecret = { Name: fields.secretId };
      }
      // console.log('serviceSecret', serviceSecret);
      if (!serviceSecret || !serviceSecret.Name) {
        setIsLoading(false);
        setValidated(false);
        setActiveTab('2');
        setIsLoading(false);
        toast.error('Credentials test missing');
      }

      await saveConfig(serviceSecret);
      // set updated secretId
      setBugServiceFrequency();
      fields.secretId = serviceSecret.Name;
      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      setIsForceRun(false);
      setIsUpdatingCreds(false);
      setActiveTab('1');
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }
  function handleToggleCustomer(index, disabled) {
    customers[index].disabled = disabled;

    setCustomers([...customers]);
  }

  function handleValidationError() {
    setModalOpen(!modalOpen);
    animateScroll.scrollTo(70);
  }

  useEffect(() => {
    setIsUpdated(true);
    if (
      bugsDateBack?.length &&
      snCompanySysId?.value &&
      priorityMaps?.length &&
      !priorityMaps.some(mapping => !mapping.snPriority || !mapping.vendorPriority) &&
      vendorRiskCategories.length &&
      (fields.secretId || fields.refreshToken)
    ) {
      setAllRequired(true);
    } else {
      setAllRequired(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fields,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    bugsDateBack,
    priorityStats,
    priorityMaps,
    keywords,
    searchFields,
    snCompanySysId,
    customers,
    vendorMitigationTypes,
    vendorRiskCategories,
    isCve,
    bugRisk
  ]);

  return (
    <>
      <TabNav
        vendorId={vendorId}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
        hasBugRisk={true}
        loading={loading}
      />

      <TabContent>
        <TabOne
          vendorId={vendorId}
          vendorLabel={vendorLabel}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          snIntegrationCheck={snIntegrationCheck}
          services={services}
          vendors={vendors}
          priorityStats={priorityStats}
          isConfigured={isConfigured}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsForceRun={setIsForceRun}
          timeUnit={timeUnit}
          setTimeUnit={setTimeUnit}
          timeValue={timeValue}
          setTimeValue={setTimeValue}
          schedulingMode={schedulingMode}
          setSchedulingMode={setSchedulingMode}
          schedules={schedules}
          setSchedules={setSchedules}
          nextRun={nextRun}
          setNextRun={setNextRun}
          loading={loading}
          isServiceActive={isServiceActive}
          setIsServiceActive={setIsServiceActive}
        />
        <form noValidate style={{ minWidth: '100%' }}>
          <input type="hidden" value="prayer" />

          <TabPane tabId="2">
            {activeTab === '2' && (
              <Card bg={'light'} text={'dak'} className="mb-4">
                {/* <FalconCardHeader title="Vendor settings" /> */}
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          NetApp API Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div>
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>
                              {/* <Button variant="outline-primary" onClick={() => setIsAddingCredentials(true)}>
                          <FontAwesomeIcon icon={'plus'} /> Set Credentials
                        </Button> */}

                              {customers.length ? (
                                <>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  NetApp Credentials Stored
                                  <Row form>
                                    <Col lg="12">
                                      <FormGroup>
                                        <Label>
                                          NetApp ActiveIQ Customers
                                          <span style={{ color: '#bd472a' }}>*</span>
                                        </Label>
                                        <ListGroup style={{ maxHeight: '500px', overflowY: 'scroll' }}>
                                          {customers.map(({ customerId, customerName, disabled }, index) => {
                                            console.log(`${customerName} ${disabled}`);

                                            return (
                                              <ListGroupItem key={customerId}>
                                                <input
                                                  type="checkbox"
                                                  checked={!disabled}
                                                  onChange={() => handleToggleCustomer(index, disabled ? 0 : 1)}
                                                />{' '}
                                                {customerName}
                                              </ListGroupItem>
                                            );
                                          })}
                                        </ListGroup>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="refreshToken"
                                  autoComplete="new-password"
                                  onChange={handleFieldChange}
                                  value={fields.refreshToken}
                                  label={'NetApp Refresh Token'}
                                  showFeedback={!isValidCredentials}
                                  feedback={'Token has not been validated or is invalid.'}
                                  placeholder="Enter NetApp refresh token"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                            </Row>
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            <ButtonIcon
                              onClick={cancelCreds}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconclassname="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        <FormFeedback
                          className={!fields.secretId && !fields.refreshToken && isSubmitted ? 'd-block' : ''}
                          type="invalid"
                        >
                          Please specify credentials.
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>

          <DefaultConfigTab
            vendor={vendor}
            activeTab={activeTab}
            vendorLabel={vendorLabel}
            bugsDateBack={bugsDateBack}
            setBugsDateBack={setBugsDateBack}
            isSubmitted={isSubmitted}
            snCompanySysIdErrors={snCompanySysIdErrors}
            snCompanySysIdOptions={snCompanySysIdOptions}
            setSnCompanySysId={setSnCompanySysId}
            snCompanySysId={snCompanySysId}
            fields={fields}
            handleFieldChange={handleFieldChange}
          />
          <TabPane tabId="4">
            {activeTab === '4' && (
              <ProductPriority
                title="Default Bug Configuration"
                vendorPriorityOptions={vendorPriorityOptions}
                vendorStatusOptions={vendorStatusOptions}
                isSubmitted={isSubmitted}
                priorityMaps={priorityMaps}
                setPriorityMaps={setPriorityMaps}
                snPriorityOptions={snPriorityOptions}
                keywords={keywords}
                setKeywords={setKeywords}
                searchFields={searchFields}
                setSearchFields={setSearchFields}
                isCve={isCve}
                setIsCve={setIsCve}
                vendorRiskCategoryOptions={vendorRiskCategoryOptions}
                vendorRiskCategories={vendorRiskCategories}
                setVendorRiskCategories={setVendorRiskCategories}
                vendorMitigationTypes={vendorMitigationTypes}
                setVendorMitigationTypes={setVendorMitigationTypes}
                vendorMitigationTypeOptions={vendorMitigationTypeOptions}
              />
            )}
          </TabPane>
          <div style={{ minWidth: '100%' }}>
            <TabPane tabId="5">
              {activeTab === '5' && <RiskScore bugRisk={bugRisk} setBugRisk={setBugRisk} riskError={riskError} />}
            </TabPane>
          </div>

          <TabPane tabId="6">{activeTab === '6' && <ExecutionStatsTab vendorId={vendorId} />}</TabPane>

          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                isAddingCredentials={isAddingCredentials}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
                handleValidationError={handleValidationError}
                allRequired={allRequired}
                isUpdated={isUpdated}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
ConfigFormNetApp.propTypes = {
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  bugs: PropTypes.object,
  priorityStats: PropTypes.object,
  setPriorityStats: PropTypes.func,
  bugOptions: PropTypes.array,
  selectedBugOption: PropTypes.object,
  setSelectedBugOption: PropTypes.func,
  snCompanySysIdErrors: PropTypes.bool,
  snCompanySysIdOptions: PropTypes.object,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  snCompanySysId: PropTypes.object,
  customers: PropTypes.array,
  setCustomers: PropTypes.func,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  isConfigured: PropTypes.bool,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  loading: PropTypes.bool,
  setVendorRiskCategories: PropTypes.func,
  vendorRiskCategories: PropTypes.array,
  vendorRiskCategoryOptions: PropTypes.array,
  isCve: PropTypes.bool,
  setIsCve: PropTypes.func,
  vendorMitigationTypes: PropTypes.array,
  setVendorMitigationTypes: PropTypes.func,
  vendorMitigationTypeOptions: PropTypes.array,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool,
  setAllRequired: PropTypes.func,
  setIsUpdated: PropTypes.func,
  bugRisk: PropTypes.array,
  setBugRisk: PropTypes.func
};
export default ConfigFormNetApp;
